<form [formGroup]="sectorService.invoiceForm" class="ledger-container">
	<div>
		<div class="invoice-container invoice-table">
			<!-- <div class="heading">INVOICE</div> -->
			<table class="table table-hovered table-bordered">
				<thead>
					<tr>
						<th>CRS ID</th>
						<th>Retrieve Id</th>
						<th>Inv. Type</th>
						<th>PNR</th>
						<th>Airline</th>
						<th>Sub Ledger Type</th>
						<th>Sub-ledger</th>
						<th>Fare Basis</th>
						<th>Deal Code</th>
						<th>Employee</th>
						<th *ngIf="salesPersonConfig=='true'" class="text-left">sales executive</th>
						<th *ngIf="referredByConfig=='true'" class="text-left">Referred by</th>
						<th *ngIf="costCenterConfig=='true'" class="text-left">COST CENTER</th>

						<th>Traveller</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<select tabIndex="{{isTenantIndian==false?5:3}}" attr.tabIndex="{{isTenantIndian==false?5:3}}" style="    width: 100%;" class="inner-select"
								(change)="getSupplier($event.target.value)" formControlName="crsId">
								<option *ngFor="let crs of crdIdArr" value="{{crs}}">{{crs}}</option>
							</select>
						</td>
						<td>
							<select tabIndex="{{isTenantIndian==false?6:4}}" attr.tabIndex="{{isTenantIndian==false?6:4}}" class="inner-select" formControlName="supplier"
								(change)="onSupplierChange($event.target.value)">
								<option *ngFor="let item of supplierArr" value="{{item.display_name}}">
									{{item.display_name}}
								</option>
							</select>
						</td>
						<td>
							<select tabIndex="{{isTenantIndian==false?7:5}}" attr.tabIndex="{{isTenantIndian==false?7:5}}" class="inner-select" (change)="onInvoiceTypeChange($event.target.value)" formControlName="invoiceType">
								<option value="B">BSP</option>
								<option value="C">C-R</option>
								<option value="X">X-O</option>
							</select>
						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorService.invoiceForm.value.pnr}}
						</td>
						<td *ngIf="manualEntryChecked"><input tabIndex="{{isTenantIndian ? 9 : 11}}" oninput="this.value = this.value.toUpperCase()" type="text"
							class="field-input" formControlName="pnr" (blur)="handlePnrInput(false)"
							[ngClass]="{'validateError': (sectorService.invoiceForm.controls.pnr.invalid && sectorService.invoiceForm.controls.pnr.touched) || 
							(!sectorService.invoiceForm.controls.pnr.valid && sectorService.submitted)}"
							maxlength="10" pattern="([A-Z0-9a-z])\w+"   [disabled]="!invoice_root_data.manualEntryChecked" />
					</td>
						<td>
							<div class="autocomplete-container">
								<div class="input-container" tabIndex="{{isTenantIndian==false?8:6}}" attr.tabIndex="{{isTenantIndian==false?8:6}}">
									<input #airlineAC 
										type="text" id=airlineAutoComplete
										(focus)="focusAirlineAc()"
										oninput="this.value = this.value.toUpperCase()" 
										name="airline_name"
										formControlName="airline_name"
										(input)="airlineSearch($event,true)"
										[nzAutocomplete]="airlineAuto"
									/>

									<nz-autocomplete #airlineAuto [nzBackfill]="true" (selectionChange)="selectAccount($event,'airline')" >
										<nz-auto-option  class="colr-1" *ngFor="let item of airlineArr" [nzValue]="item" [nzLabel]="item.name">
											<a
												innerHTML='<span class="colr-1 selected-ng">{{item.name}} ({{item.account_code}})</span>'>
											</a>                            
										</nz-auto-option>                      
									</nz-autocomplete>
						     	</div>
							</div>
						</td>
						<td>
							<select class="inner-select" tabIndex="{{isTenantIndian==false?9:7}}" attr.tabIndex="{{isTenantIndian==false?9:7}}" formControlName="sub_ledger_code_1_type"
								(change)="getAccounts($event.target.value)">
								<option value="">None</option>
								<option value="client">Client</option>
								<option value="airline">Airline</option>
								<option value="supplier">Supplier</option>
								<option value="general">General</option>
							</select>

						</td>
						<td>
							<div class="autocomplete-container">
								<div class="input-container">
									<input #subLedgerAC tabIndex="{{isTenantIndian==false?10:8}}" attr.tabIndex="{{isTenantIndian==false?10:8}}"
										type="text"
										(focus)="focusSubledgerAc()"
										oninput="this.value = this.value.toUpperCase()" 
										name="sub_ledger_code_1_name"
										formControlName="sub_ledger_code_1_name"
										(input)="ledgerSearch($event,true)"
										[nzAutocomplete]="subLedgerAC"
									/>

									<nz-autocomplete #subLedgerAC [nzBackfill]="true" (selectionChange)="selectAccount($event,'sub_ledger_code_1')" >
										<nz-auto-option  class="colr-1" *ngFor="let item of sectorService.ledgerList" [nzValue]="item" [nzLabel]="item.name">
											<a
												innerHTML='<span class="colr-1 selected-ng">{{item.name}} ({{item.account_code}})</span>'>
											</a>                            
										</nz-auto-option>                      
									</nz-autocomplete>
								</div>
							</div>

						</td>
						<td *ngIf="!manualEntryChecked">
							{{sectorService.invoiceForm.value.fareBasis}}
						</td>
						<td *ngIf="manualEntryChecked"><input  tabIndex="{{isTenantIndian ? 13 : 15}}" oninput="this.value = this.value.toUpperCase()" type="text"
							class="field-input" formControlName="fareBasis" pattern="^[a-zA-Z0-9_]*$"  maxlength="10"/></td>
						<td *ngIf="!manualEntryChecked">
							{{sectorService.invoiceForm.value.dealCode}}
						</td>
						<td *ngIf="manualEntryChecked"><input tabIndex="16" oninput="this.value = this.value.toUpperCase()" type="text" tabIndex="{{isTenantIndian ? 14 : 16}}"
							class="field-input" formControlName="dealCode" pattern="^[a-zA-Z0-9_]*$" maxlength="10"/></td>
						<td *ngIf="!manualEntryChecked">
							{{sectorService.invoiceForm.value.employee_name}}
						</td>
						<td *ngIf="manualEntryChecked">
							<div class="autocomplete-container">
								<div class="input-container">
							<input #employeeAC style="text-transform: uppercase;" disabled
								[ngClass]="{'validate-ng-error': (sectorService.invoiceForm.controls.employee_name.invalid && sectorService.invoiceForm.controls.employee_name.touched) ||
								(!sectorService.invoiceForm.controls.employee_name.valid && sectorService.submitted)}"
								type="text" (focus)="focusEmployeeAc()"  
								oninput="this.value = this.value.toUpperCase()" 
								name="employee_name"
								formControlName="employee_name"
								(input)="employeeSearch($event)"
								[nzAutocomplete]="employeeAuto"
							/>

							<nz-autocomplete #employeeAuto [nzBackfill]="true" (selectionChange)="selectAccount($event,'employee_name')">
								<nz-auto-option  class="colr-1" *ngFor="let item of sectorService.employeeList" [nzValue]="item" [nzLabel]="item.name"
								 >
								    <a innerHTML='<span class="colr-1 selected-ng">{{item.name}}({{item.account_code}})</span><br />'></a>                           
								</nz-auto-option>                      
							</nz-autocomplete>

							
							<span class="text-danger" *ngIf="sectorService.invoiceForm.value.employee == ''">Please
								Enter
								Employee</span>
							</div>
							</div>
						</td>
						<td *ngIf="salesPersonConfig=='true' && !manualEntryChecked">{{sectorService.invoiceForm.value.sales_person_name}}
						</td>
						<td *ngIf="salesPersonConfig=='true' && manualEntryChecked">
							<div class="autocomplete-container">
								<div class="input-container">
							<input #salesPersonAC style="text-transform: uppercase;" 
								type="text" 
								oninput="this.value = this.value.toUpperCase()" 
								name="sales_person_name"
								formControlName="sales_person_name"
								(input)="salesPersonSearch($event)"
								[nzAutocomplete]="salesPersonAuto"
								(blur)="validateSalesPerson(salesPersonAC.value,1)"
							/>

							<nz-autocomplete #salesPersonAuto [nzBackfill]="true" (selectionChange)="selectSalesPerson($event,'sales_person_name')">
								<nz-auto-option  class="colr-1" *ngFor="let item of salesPersonArr" [nzValue]="item" [nzLabel]="item.t_user_name"
								 >
								    <a innerHTML='<span class="colr-1 selected-ng">{{item.t_user_name}}({{item.user_code}})</span><br />'></a>                           
								</nz-auto-option>                      
							</nz-autocomplete>
							<!-- <select class="input-field" tabIndex="1" formControlName="sales_person_name"  >
								<option selected >SELECT</option>
								<ng-container *ngIf="salesPersonArr != undefined">
								  <option *ngFor="let item of salesPersonArr" [ngValue]="item.t_user_name">{{item.t_user_name}}</option>
								</ng-container>
							  </select> -->
							  </div>
							  </div>
						</td>
						<td *ngIf="referredByConfig=='true' && !manualEntryChecked">{{sectorService.invoiceForm.value.refered_by_name}}
						</td>
						<td *ngIf="referredByConfig=='true' && manualEntryChecked">
							<div class="autocomplete-container">
								<div class="input-container">
							<input #ReferedByAC style="text-transform: uppercase;" 
								type="text" 
								oninput="this.value = this.value.toUpperCase()" 
								name="refered_by_name"
								formControlName="refered_by_name"
								(input)="referedBySearch($event)"
								[nzAutocomplete]="referedByAuto"
								(blur)="validateReferedBy(ReferedByAC.value,1)"
							/>

							<nz-autocomplete #referedByAuto [nzBackfill]="true" (selectionChange)="selectReferedBy($event,'refered_by_name')">
								<nz-auto-option  class="colr-1" *ngFor="let item of referedByArr" [nzValue]="item" [nzLabel]="item.name"
								 >
								    <a innerHTML='<span class="colr-1 selected-ng">{{item.name}}({{item.account_code}})</span><br />'></a>                           
								</nz-auto-option>                      
							</nz-autocomplete>
							</div>
							</div>
						</td>
						<td *ngIf="costCenterConfig=='true' && !manualEntryChecked">{{sectorService.invoiceForm.value.invoice_cost_center}}
						</td>
						<td *ngIf="costCenterConfig=='true' && manualEntryChecked">
							<div class="autocomplete-container">
								<div class="input-container">
							<input #costCenterAC style="text-transform: uppercase;" 
								type="text" 
								oninput="this.value = this.value.toUpperCase()" 
								name="invoice_cost_center"
								formControlName="invoice_cost_center"
								(input)="costCenterSearch($event)"
								[nzAutocomplete]="costCenterAuto"
								(blur)="validateCostCenter(costCenterAC.value,1)"
							/>
							<nz-autocomplete #costCenterAuto [nzBackfill]="true" (selectionChange)="selectCostCenter($event,'invoice_cost_center')">
								<nz-auto-option  class="colr-1" *ngFor="let item of groupList" [nzValue]="item.name" [nzLabel]="item.name"
								 >
								    <a innerHTML='<span class="colr-1 selected-ng">{{item.name}}</span><br />'></a>                           
								</nz-auto-option>                      
							</nz-autocomplete>
						  </div>
						  </div>
						</td>
						<!-- <td><input  oninput="this.value = this.value.toUpperCase()" type="text" class="field-input" formControlName="payable" /></td> -->
						<td *ngIf="!manualEntryChecked">
							{{sectorService.invoiceForm.value.travellerCount}}
						</td>
						<td *ngIf="manualEntryChecked">
							<input style="width: 50px!important;" tabIndex="{{isTenantIndian ? 16 : 18}}"
								oninput="this.value = this.value.toUpperCase()" type="number" class="field-input"
								formControlName="travellerCount" (change)="onTravellerBlur($event)" name="traveller" />
						</td>
					</tr>
				</tbody>
			</table>
			<app-sector-info-refund [sectorService]="sectorService" [isTenantIndian]="isTenantIndian" [manualEntryChecked]="manualEntryChecked"></app-sector-info-refund>
			<app-traveller-info-refund (callSaveTraveller)="saveProductInvoice()" [invoiceNumber]="invoice_no" [manualEntryChecked]="manualEntryChecked"
				[invoice_root_data]="invoice_root_data" [sectorService]="sectorService"></app-traveller-info-refund>
			<app-total-fare-info-refund [sectorService]="sectorService"></app-total-fare-info-refund>
			<!-- <div class="traveller-action-col d-flex justify-content-center mt-4">
				<button class="action-btn mb-5" (click)="saveProductInvoice()"
					[ngClass]="{disbaledBtn: sectorService.travellerForm.invalid || sectorService.invoiceForm.invalid || sectorService.sectorForm.invalid}"
					[disabled]="sectorService.travellerForm.invalid || sectorService.invoiceForm.invalid || sectorService.sectorForm.invalid">
					Save
				</button>

				<button (click)="closeMaxModule()" class="action-btn mb-5 ml-3">
					Cancel
				</button>
			</div> -->

		</div>
	</div>
</form>